export default "__VITE_ASSET__D4J$tGPQ__"